import { useRef, useEffect, useState } from "react";
import { Shield, Star, Lock } from "lucide-react";

const pillars = [
  {
    icon: Shield,
    title: "Cuidadores verificados",
    description: "Revisamos identidad y antecedentes de cada cuidador antes de activar su perfil.",
  },
  {
    icon: Star,
    title: "Reseñas reales",
    description: "Solo dueños que completaron el servicio pueden dejar una reseña.",
  },
  {
    icon: Lock,
    title: "Pagos 100% seguros",
    description: "Cobro dentro de la plataforma. El cuidador recibe el pago solo al finalizar el servicio.",
  },
];

const TrustPillars = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="section-padding" style={{ background: 'white' }}>
      <div className={`container-custom mx-auto transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl md:text-6xl font-fredoka font-bold mb-4" style={{ color: '#252a2a' }}>
            Tu tranquilidad, nuestra prioridad
          </h2>
          <p className="text-lg md:text-2xl font-poppins max-w-2xl mx-auto" style={{ color: '#252a2a' }}>
            Cada detalle está pensado para que confíes en nosotros.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {pillars.map((p, i) => (
            <div key={i} className="text-center">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(64, 137, 200, 0.1)' }}>
                <p.icon className="w-8 h-8" style={{ color: '#3273a4' }} />
              </div>
              <h3 className="font-fredoka text-lg md:text-xl font-semibold mb-2" style={{ color: '#252a2a' }}>{p.title}</h3>
              <p className="font-poppins text-base leading-relaxed" style={{ color: '#252a2a' }}>{p.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustPillars;
